export default "__VITE_ASSET__NpYEL7LL__"